import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardLayout from "@/pages/DashboardLayout";
import YarnMasterPage from "@/pages/YarnMasterPage";
import BorderMasterPage from "@/pages/BorderMasterPage";
import CostingCalculatorPage from "@/pages/CostingCalculatorPage";
import CalculationHistoryPage from "@/pages/CalculationHistoryPage";
import SavedDesignsPage from "@/pages/SavedDesignsPage";
import CompareDesignsPage from "@/pages/CompareDesignsPage";
import WeaverMasterPage from "@/pages/WeaverMasterPage";
import WeaverComparePage from "@/pages/WeaverComparePage";
import ItemMasterPage from "@/pages/ItemMasterPage";
import VendorMasterPage from "@/pages/VendorMasterPage";
import TrimsMasterPage from "@/pages/TrimsMasterPage";
import BulkImportPage from "@/pages/BulkImportPage";
import ComboCostPage from "@/pages/ComboCostPage";
import ProcessingMasterPage from "@/pages/ProcessingMasterPage";
import SettingsPage from "@/pages/SettingsPage";
import PinLoginPage from "@/pages/PinLoginPage";
import ViewerLayout from "@/pages/ViewerLayout";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/calculator" replace /> : <LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/calculator" replace />} />
        <Route path="calculator" element={<CostingCalculatorPage />} />
        <Route path="yarn-master" element={<YarnMasterPage />} />
        <Route path="border-master" element={<BorderMasterPage />} />
        <Route path="processing-master" element={<ProcessingMasterPage />} />
        <Route path="history" element={<CalculationHistoryPage />} />
        <Route path="designs" element={<SavedDesignsPage />} />
        <Route path="compare" element={<CompareDesignsPage />} />
        <Route path="weavers" element={<WeaverMasterPage />} />
        <Route path="weaver-compare" element={<WeaverComparePage />} />
        <Route path="item-master" element={<ItemMasterPage />} />
        <Route path="vendors" element={<VendorMasterPage />} />
        <Route path="trims-master" element={<TrimsMasterPage />} />
        <Route path="bulk-import" element={<BulkImportPage />} />
        <Route path="combo" element={<ComboCostPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      {/* Chairman PIN-based view-only access */}
      <Route path="/view" element={<PinLoginPage />} />
      <Route path="/view/calculator" element={<ViewerLayout />}>
        <Route index element={<CostingCalculatorPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/calculator" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
